import React, { useEffect, useState,useRef} from "react";
// import { Highlight } from "react-instantsearch-dom";
// import Link from "next/link";
// import Image from "next/image";
import ProductListingDetails from "../ProductListingDetails";
import ProductTagComp from "../../ProductTagComp";
import QuickBuyComp from "../../QuickBuyComp";
import PlpWishlistComp from "../../PlpWishlistComp";
import SrcsetPLP from "@/components/common/SrcsetPLP";
import Srcset from "@/components/common/Srcset";
// import { autocomplete } from "@algolia/autocomplete-js";
import { useDispatch, useSelector } from "react-redux";
import Head from "next/head";
// import Script from "next/script";
import { imgURL, makeId, srcsetMaker } from "@/helpers/userHelpers";
import { Klaviyo_viewed_product } from "@/components/common/Klaviyo";
// import { PRODUCT_MEDIA_QUERY } from "gql/productMedia";
// import apolloClient from "gql/apolloClient";
import useMediaQuery from "@/helpers/hooks/useMediaQuery" ;

import {
  selectPLPVariant,
} from "@/helpers/pdpHelpers/pdpVariantHelpers";
import { getVariantFinalOptions } from "@/helpers/plpHelper";
import { useRouter } from "next/compat/router";
import { generalConstants } from "@/utils/constants";
import { reportError } from "@/helpers/errorHelper";
import { showPwaLoader } from "@/redux/actions/pwaAction";
import QuickBuyLite from "@/components/QuickBuyLite";
import { client } from "@/utils/netlify";
import { useDPIScreenCheck } from "@/hooks/useDPIScreenCheck";

const ProductItemTile = (props) => {
  const dispatch = useDispatch();
  const [product_select, setProduct_select] = useState();
  const [clicked, setClicked] = useState(false);
  const [hideQuickBuy, setHideQuickBuy] = useState(false);
  const [showQuickBuyOption, setShowQuickBuyOption] = useState(false);
  const [generateQuickBuy, setGenerateQuickBuy] = useState(false);
  const [hrefwithObjectId, setHrefwithObjectId] = useState(false); //used to set the value for href on product click
  const [primaryImage, setPrimaryImage]=useState("");

  //state to handle hover on PLP color swatches
  const [plpSwatchHover, setPlpSwatchHover]=useState({
    color:"",
    img:""
  });
  let logUser = useSelector((state) => state.loginUser);
  const isPWA = useSelector((state) => state.pwa.is_PWA);
  const { shouldAddRandomId } = props;
  let randomId = null;
  if(shouldAddRandomId) {
    randomId = makeId(3);
  }

  const handleClick = (e) => {
    if(isPWA) {
      dispatch(showPwaLoader(true))
    }
  }

  // if e contains color, then set the color in plpSwatchHover state
  const handlePLPSwatchHover = (e) => {
    if(e) setPlpSwatchHover({color:e,img:""})
    else setPlpSwatchHover({
      color:"",
      img:""
    })
  };

  // for product having color variants, they will be added with "productid-color" in the variant grouping metafield
  const isVariantGroupingAdded = () => {
    if (product?.meta?.custom?.variant_grouping && product.meta?.custom?.variant_grouping.split("-")?.length > 1) {
      return product.meta?.custom?.variant_grouping.split("-")[1];
    }
    return false;
  }

  const myLoader = ({ src, width, height, quality }) => {
    return `${src}?w=${width}&h=${height}&q=${quality || 75}`;
  };
  const [imageDiv, setImageDiv] = useState('');  
  let badge_curated;
  let moreInfo_tag;
  let product = null;
  let wishlistFeatureEnabled = true;
  let impactMessageEnabled = true;
  const isOnlyMobile = useMediaQuery("(max-width: 767px)");
  
  if ((props.isCarousel || props.isWishlist) && props.productDetails) {
    product = props.productDetails;
  } else {
    product = props.hit;
  }

  if (typeof props.wishlistFeatureEnabled != "undefined") {
    wishlistFeatureEnabled = props.wishlistFeatureEnabled;
  }
  if (typeof props.impactMessageEnabled != "undefined") {
    impactMessageEnabled = props.impactMessageEnabled;
  }
  let lazyLoad = false;
  if (isOnlyMobile && props.itemkey > 2) {
    lazyLoad = true;
  } else if (props.itemkey > 4) {
    lazyLoad = true;
    
  }

  if (product.named_tags && product.named_tags.Badge_curated1) {
    //If there is an array of badge_curated1 tags then selling fast tag supersedes all other tags
    //Tag has lowercase 'f' , FE should be displayed with 'F'
    if(product.named_tags.Badge_curated1.includes("Selling fast")){
      badge_curated = "Selling Fast"
    } else {
      badge_curated = product.named_tags.Badge_curated1 && Array.isArray(product.named_tags.Badge_curated1) ? product.named_tags.Badge_curated1[0] : product.named_tags.Badge_curated1;
    }
  } else if (product.named_tags && product.named_tags.Badge_curated) {
    badge_curated = product.named_tags.Badge_curated && Array.isArray(product.named_tags.Badge_curated) ? product.named_tags.Badge_curated[0] : product.named_tags.Badge_curated;
  }

try{
  if (product.named_tags) {
    //do not display tag2 for carousel
    //if the product tags include tag2 as "ENGRAVING AVAILABLE" it should be displayed with the highest priority
    //if the product tags include tag2 then tag2 should be displayed with the highest priority
    //  if a product tagged with the Badge:New then tag2 is not applicable
    //Tag:Fast shipping is having the 3rd priority to display after Tag2 and Tag1
    if(product.named_tags.Tag2 && product.named_tags.Tag2 === "ENGRAVING AVAILABLE"){
      moreInfo_tag = Array.isArray(product.named_tags.Tag2) ? product.named_tags.Tag2[0] : product.named_tags.Tag2; 
    }  else if (product.named_tags.Tag2 && !props.isCarousel && !(product.named_tags?.Badge ==="New") && !(product.named_tags?.Availability==="Pre-order") && !(product.named_tags.Tag_curated==="MADE TO ORDER")){
      moreInfo_tag = Array.isArray(product.named_tags.Tag2) ? product.named_tags.Tag2[0] : product.named_tags.Tag2;
    } else if (product.named_tags.Tag1) {
      //  if the product has Tag1, Tag_curated1 and Tag_curated, then  "Tag1" tag takes highest Priority
      moreInfo_tag = Array.isArray(product.named_tags.Tag1) ? product.named_tags.Tag1[0] : product.named_tags.Tag1;
    } else if (product?.named_tags?.Tag && product?.named_tags?.Tag?.toLowerCase()==='fast shipping') {
      //  if the product has Tag1, Tag_curated1 and Tag_curated, then  "Tag1" tag takes highest Priority
      moreInfo_tag =product.named_tags.Tag;
    } else if (product.named_tags.Tag_curated1) {
      //  if the product has Tag_curated1 and Tag_curated, then  "Tag_curated1" tag takes highest Priority
      moreInfo_tag = Array.isArray(product.named_tags.Tag_curated1) ? product.named_tags.Tag_curated1[0] : product.named_tags.Tag_curated1;
    } else if (product.named_tags.Tag_curated) {
      //  if the product has only  "Tag_curated" tag
      moreInfo_tag = Array.isArray(product.named_tags.Tag_curated) ? product.named_tags.Tag_curated[0] : product.named_tags.Tag_curated;
    }
  }
} catch(e){
    reportError("Named tags error");
    reportError(e)
}

  const [secondaryImg,setSecondaryImg]=useState({});
  const [variantsFinalOptions,setVariantsFinalOptions]=useState({});
  const [quickBuyClicked,setQuickBuyClicked]=useState(false);
  const [productDetails,setProductDetails]=useState();
  const [selectedColor, setSelectedColor] = useState(null);
  const [selectedSize, setSelectedSize] = useState(null);
  const [selectedLetter, setSelectedLetter] = useState(null);

  // generate priamry image based on the product variant 
  const handlePrimaryImage = (productDetails) => {
    let variants = productDetails.variants.edges;
    let color = isVariantGroupingAdded()
    let image;
    if (variants && color) {
      variants.forEach((variant,i) => {
        if (variant.node.title?.includes(color)) {
          image = variant.node?.image?.src;
          return;
        }
    })}
    // if image is not found in the variants, then use the default image available at product level
    if (image) {
      setPrimaryImage(image);
    } else {
      setPrimaryImage(product.product_image);
    }
  }

  // Genetrate secondary image based on primary image
  const handleSecondaryImage = () => {
    if(!isOnlyMobile) {
      let images = productDetails?.media?.edges;
      if(images && images.length > 0) {
        // generate first and second image
        let firstImg = images[0]?.node.image && images[0]?.node.mediaContentType!="VIDEO" ? images[0]?.node.image.url : null;
        let secondImg = images[1]?.node.image && images[1]?.node.mediaContentType!="VIDEO" ? images[1]?.node.image.url : null;

        if(secondImg) {
          // if primary image is same as secondary image then set the secondary image to first image else set it to second image
          if(primaryImage === secondImg) {
            let ret = [];
            ret[product.handle] = firstImg;
            setSecondaryImg(ret)
          } else {
            let ret = [];
            ret[product.handle] = secondImg;
            setSecondaryImg(ret)
          }
        }
      }
    }
  }

  const getResponse=async(handle)=>{
    setShowQuickBuyOption(false)
    setVariantsFinalOptions({})
    setQuickBuyClicked(false)
    setProductDetails()
    setSelectedColor()
    setSelectedSize()
    setSelectedLetter()
    const res = await client("get-plp-products-data", {"handle": handle});
    if(res?.data?.productByHandle) {
      setProductDetails(res.data.productByHandle);
      handlePrimaryImage(res.data.productByHandle);
      let ret = getVariantFinalOptions(res.data.productByHandle.variants.edges,res.data.productByHandle.options,res.data.productByHandle.tags,handle)
      setVariantsFinalOptions(ret);
      setSelectedSize(ret.sizes && ret.sizes.length==1 ? ret.sizes.find(el => el !== undefined) : null);
      if(res.data.productByHandle.tags.includes("personalized")) {
        setSelectedLetter(ret.letters && ret.letters.length==1 ? ret.letters.find(el => el !== undefined) : null);
        setSelectedColor(null);
      } else {
        setSelectedColor(ret.colors && ret.colors.length==1 ? ret.colors.find(el => el !== undefined) : null);
        setSelectedLetter(null)
      }
      setShowQuickBuyOption(true)
    }
  }

  const [loaded, setLoaded] = useState(false);  
  const imgEl = useRef(null);
  const onImageLoaded = () => setLoaded(true);

  useEffect(()=>{
    if(!isOnlyMobile && secondaryImg[product.handle]!="" && imgEl && imgEl.current){
      const imgElCurrent = imgEl.current;
      imgElCurrent.addEventListener('load', onImageLoaded);
      return () => imgElCurrent.removeEventListener('load');
    }
  },[product.handle,imgEl,props.searchComp,generateQuickBuy]); 

  useEffect(()=>{
    if (!props.isMobile) {
      // fire get-plp-products-data api inside getReponse() incrementally with a delay of 100. 
      // implemenated this approach, to minimize 499 errors for get-plp-products-data api
      const timer = props.itemkey ? 100 * props.itemkey : 0
      setTimeout(() => {
        getResponse(product.handle);
      }, timer);
    } else if(props.isMobile && isVariantGroupingAdded()){
      const timer = props.itemkey ? 100 * props.itemkey : 0
      setTimeout(() => {
        getResponse(product.handle);
      }, timer);
    }
  },[props.isMobile,props.searchComp,product.handle ])

  // if primary image is updated, generate the secondary image based on that
  useEffect(()=>{
    if(primaryImage) {
      handleSecondaryImage()
    }
  },[primaryImage])

  // set variant image based on the color in plpSwatchHover
  useEffect(()=>{
    if(plpSwatchHover.color) {
      let variants = productDetails.variants.edges;
      if (variants) {
        variants.forEach((variant) => {
          if (variant.node.title?.includes(plpSwatchHover.color)) {
            setPlpSwatchHover(prevState => ({...prevState, img: variant.node?.image?.src}));
            return;
          }
      })}
    }
  },[plpSwatchHover.color])

  useEffect(()=>{
    productDetails?.tags?.map((element) => {
      if (element.split(":").shift() === "categories.lvl0") {
        productDetails.named_tags = {
          category: element?.split(":").pop(),
        };
      }
    });
    if(productDetails) {
      productDetails.productType =productDetails?.product_type?.value
      ? productDetails.product_type.value
      : "regular";
    }
  },[productDetails]);

  const selectedVariant = selectPLPVariant(
    null,
    variantsFinalOptions.variantMap,
    selectedColor,
    selectedSize,
    selectedLetter,
    variantsFinalOptions.sizes ? variantsFinalOptions.sizes.length : 0,
    setSelectedSize,
    product.id
  );

useEffect(()=>{
  Klaviyo_viewed_product(product_select,logUser?.UserData?.email, process.env.NETLIFY_URL)
}, [product_select])

 //function to update the objectID query param to the url.
  function addOrUpdateURLParam (key, value) {
    let href = process.env.NETLIFY_URL + "/products/" + product.handle;
    const searchParams = new URLSearchParams(window.location.search);
    searchParams.set(key, value)
    if(window.location.search?.includes("search_source=oli_plp")){
      searchParams.set("search_source", "oli_pdp")
    }
    const newRelativePathQuery = href.includes("?") ? href + "&" + searchParams.toString() : href + "?" + searchParams.toString()
    return newRelativePathQuery;
  }

//'item_list_name': listPath is added in the below datalayer to get the products clicked in a list
const router = useRouter();
const productClick = () => {  
  if(props.hit?.__queryID){
    //set the queryID in the localstorage on product click to retrieve it in Add to bag conversion event
    localStorage.setItem("queryID",props.hit.__queryID);
  }
  if(props.hit?.objectID){
    //set the hrefwithObjectId with updated url
    setHrefwithObjectId(addOrUpdateURLParam("objectId",props?.hit?.objectID));
  } else {
    setHrefwithObjectId(process.env.NETLIFY_URL + "/products/" + product.handle);
  }
  var listPath = router.asPath;
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      'event': 'productClick',
      'ecommerce': {
        'click': {
          'actionField': {
            'list': listPath
          },
          'products': [{
            'name': product.title,
            'id': product.id,
            'brand':product.vendor,
            'price':product.price,
            'variant': product.variant_title,
            'category': product?.product_type,  //Category should be same as defined in productType
            'position':1,
            'item_list_name': listPath,
          }]
        }
      }
      });
  }

  const MAX_WIDTH = 310;
  const MAX_HEIGHT = 400;

  const isHighDPIScreen = useDPIScreenCheck() ? 2 : 1;
  
  return (
    <>
    <Head>
      {lazyLoad ? null:product.product_image ?<link rel="preload" as="image" href={imgURL(product.product_image,'grande') } imagesrcset={srcsetMaker(product.product_image)} imagesizes="100vw"></link> : null}
    </Head>
      <a
        href={ typeof window!="undefined" && props.hit?.objectID ? addOrUpdateURLParam("objectId",props?.hit?.objectID) : `${process.env.NETLIFY_URL}/products/${product.handle}${product?.objectID ? `?objectId=${product.objectID}` : ""}`} //update url with object id and without object id
        onClick={() => {
          props.autocomplete?.refresh();
          productClick();
        }}
        className="exclude-pwa-loader"
        data-product_id={product.id}
        tabIndex={0}
      >
        <div
          className="search-product-tile"
          onClick={() => {
            setProduct_select(product);
            setClicked(true);
          }}
        >
          <div className="hit-image">
          <div className="img-wrapper" onClick={(e) => handleClick(e)}>
            {/*  single-variant class is added conditionally to enable the hover effect */}
          <div className={`hit-img ${secondaryImg[product.handle] =="" || !loaded?"single-variant":""}`}>
          {!isOnlyMobile ? (
                <>
                  <SrcsetPLP
                    height={MAX_HEIGHT}
                    width={MAX_WIDTH}
                    src={primaryImage ? plpSwatchHover.img ? plpSwatchHover.img : primaryImage : product.product_image} // use primary image if swatch hover image is not available
                    title={product.title}
                    alt={`${product.vendor} ${product.title}`}
                    id={`image-${product.id}${randomId ? "-" + randomId : ""}`}
                    lazyLoad={lazyLoad}
                    isHighDpi={isHighDPIScreen}
                  />
                  <span className="img-bg"></span>
                </>
                ) : (
                  <Srcset
                    height="100%"
                    width="100%"
                    src={primaryImage ? plpSwatchHover.img ? plpSwatchHover.img : primaryImage : product.product_image} // use primary image if swatch hover image is not available
                    title={product.title}
                    alt={`${product.vendor} ${product.title}`}
                    id={`image-${product.id}${randomId ? "-" + randomId : ""}`}
                    lazyLoad={lazyLoad}
                  />
                )}
            
          </div>
          {/* Uncomment the below code if you want to enable the second image hover */}
          {!isOnlyMobile && secondaryImg[product.handle] && <div className="hit-img-hover">
            <SrcsetPLP
              height={MAX_HEIGHT}
              width={MAX_WIDTH}
              src={secondaryImg[product.handle]}
              title={product.title}
              alt={`${product.vendor} ${product.title}`}
              id={`image-second-${product.id}`}
              itemkey={props.itemkey}
              ref={imgEl}
              isHighDpi={isHighDPIScreen}
              // lazyLoad={lazyLoad}
            />
            <span className="img-bg"></span>
          </div>}
          </div>
          {wishlistFeatureEnabled && productDetails && !generalConstants.gift_card_type.includes(product.product_type) && <PlpWishlistComp
            product={product}
            productDetails={productDetails}
            isOnlyMobile={isOnlyMobile}
            searchComp={props.searchComp}
          />}
            {!isOnlyMobile && showQuickBuyOption && variantsFinalOptions.showQuickBuy &&
              < QuickBuyComp qb_array={variantsFinalOptions}
                selectedColor={selectedColor}
                setSelectedColor={setSelectedColor}
                selectedLetter={selectedLetter}
                setSelectedLetter={setSelectedLetter}
                selectedSize={selectedSize}
                setSelectedSize={setSelectedSize}
                selectedVariant={selectedVariant}
                handle={product.id}
                product_handle={product.handle}
                quickBuyClicked={quickBuyClicked}
                setQuickBuyClicked={setQuickBuyClicked}
                badge_curated={badge_curated}
                link={`${process.env.NETLIFY_URL}/products/${product.handle}${props?.hit?.objectID ? `?objectId=${props?.hit?.objectID}` : ""}`}
                productDetails={productDetails}
                // isOnlyMobile={isOnlyMobile}
                productImage={product.product_image}
                searchComp={props.searchComp}
                generateQuickBuy={generateQuickBuy}
                setGenerateQuickBuy={setGenerateQuickBuy}
                objectID={props?.hit?.objectID} //Pass ObjectID to QuickBuy for algolia conversion
                queryID={props?.hit?.__queryID} //Pass QueryID to QuickBuy for algolia conversion
                device={isPWA ? "app": props.isMobile ? "mobile" : "desktop"}
              />
          }
          {isOnlyMobile&&
          <QuickBuyLite
            product_handle={product.handle}
            badge_curated={badge_curated}
            link={`${process.env.NETLIFY_URL}/products/${product.handle}`}
            productDetails={productDetails}
            productImage={product.product_image}
            searchComp={props.searchComp}
            objectID={props?.hit?.objectID} //Pass ObjectID to QuickBuy for algolia conversion
            queryID={props?.hit?.__queryID} //Pass QueryID to QuickBuy for algolia conversion
            device={isPWA ? "app": props.isMobile ? "mobile" : "desktop"}
           />
          }
          
            <ProductTagComp cname="product-tag indexed xx-small" cvalue={badge_curated}/>
          </div>
          <div className="hit-content" id={`product-info-${product.id}${randomId ? "-" + randomId : ""}`} onClick={(e) => handleClick(e)}>
            <div className="hit-name">
              {/* <Highlight attribute="name" hit={product} /> */}
            </div>
            <div className="hit-description">
              {/* <Highlight attribute="description" hit={product} /> */}
            </div>
            <ProductListingDetails variantsFinalOptions={variantsFinalOptions} product={product} randomId={randomId} moreInfo_tag={moreInfo_tag} handlePLPSwatchHover={handlePLPSwatchHover} searchComp={props.searchComp}/>
          </div>
        </div>
      </a>
    </>
  );
};

export default ProductItemTile;
